<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between">
    <h5 class="mb-0">Members Grid</h5>
    <ol class="breadcrumb mb-0 ps-0">
        <li class="breadcrumb-item">
            <a routerLink="/">
                <i class="ri-home-8-line"></i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item gray-color">Contacts</li>
        <li class="breadcrumb-item fw-semibold">Members Grid</li>
    </ol>
</div>

<div class="row" [class.component-rtl-enabled]="themeService.isRTLEnabled()">
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Alvarado Turner</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user12.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@alvaradoturner</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:alvaradoturner@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            alvaradoturner@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Evangelina Mcclain</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user13.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@evangelinamcclain</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:evangelinamcclain@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            evangelinamcclain@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Candice Munoz</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user11.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@candicemunoz</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:candicemunoz@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            candicemunoz@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Bernard Langley</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user14.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@bernardlangley</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:bernardlangley@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            bernardlangley@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Kristie Hall</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user8.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@kristiehall</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:kristiehall@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            kristiehall@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Bolton Obrien</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user23.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@boltonobrien</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:boltonobrien@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            boltonobrien@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Dee Alvarado</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user18.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@deealvarado</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:deealvarado@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            deealvarado@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Cervantes Kramer</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user22.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@cervanteskramer</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:cervanteskramer@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            cervanteskramer@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Dejesus Michael</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user16.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@dejesusmichael</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:dejesusmichael@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            dejesusmichael@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Alissa Nelson</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user15.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@alissanelson</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:alissanelson@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            alissanelson@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">English Haney</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user9.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@englishhaney</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:englishhaney@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            englishhaney@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
        <mat-card class="mb-25 text-center tagus-card">
            <mat-card-header class="border-bottom">
                <h5 class="mb-0">Edwards Mckenzie</h5>
                <button type="button" mat-button class="position-relative dot-btn p-0 bg-transparent border-none" [matMenuTriggerFor]="monthMenu">
                    <i class="ri-more-fill"></i>
                </button>
                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-add-circle-line"></i> Add
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-delete-bin-6-line"></i> Delete
                    </button>
                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative">
                        <i class="ri-restart-line"></i> Refresh
                    </button>
                </mat-menu>
            </mat-card-header>
            <mat-card-content>
                <img src="assets/img/user/user17.jpg" class="rounded-circle mb-15" width="150" alt="user">
                <span class="d-block gray-color fw-medium">@edwardsmckenzie</span>
                <ul class="list ps-0 mb-0">
                    <li class="gray-color fw-medium">
                        <a href="tel:+9003526765" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-phone-call"></i>
                            +9003526765
                        </a>
                    </li>
                    <li class="gray-color fw-medium">
                        <a href="mailto:edwardsmckenzie@mdgestaoemsaude.com" class="gray-color d-inline-block position-relative">
                            <i class="flaticon-envelope"></i>
                            edwardsmckenzie@mdgestaoemsaude.com
                        </a>
                    </li>
                </ul>
            </mat-card-content>
        </mat-card>
    </div>
</div>